import { Button } from '@design/components/button/Button';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './ClearFiltersButton.module.scss';

export interface ClearFiltersButtonProps {
  label?: string;
  onClick: () => void;
}

export const ClearFiltersButton = ({
  label,
  onClick,
  ...rest
}: ClearFiltersButtonProps) => {
  const { t } = useTranslation('news');

  return (
    <Button
      className={styles.styledButton}
      data-testid="clear-filters-button"
      label={label ?? t('news:resetAllFilters')}
      iconName="Reset"
      iconPosition="left"
      onClick={onClick}
      variant="empty"
      size="small"
      {...rest}
    />
  );
};
